export const listItemWrapper = ({ isActiveItem }: { isActiveItem: boolean }) => ({
	height: '4rem',
	padding: '1rem 1.25rem',
	gap: '0.25rem',
	borderRadius: '0.5rem',
	backgroundColor: isActiveItem ? 'neutrals.neutral' : 'transparent',
});

export const listWrapper = {
	display: 'flex',
	flex: 1,
	flexDirection: 'column',
	justifyContent: 'space-between',
};

export const toolbarWrapper = {
	paddingRight: '0px',
	display: 'flex',
	justifyContent: 'flex-end',
};

export const listBoxWrapper = {
	display: 'flex',
	flex: 1,
	flexDirection: 'column',
};

export const logoutBoxWrapper = {
	display: 'flex',
	flex: 1,
	flexDirection: 'column',
	justifyContent: 'flex-end',
};

export const listItemButton = {
	maxHeight: '6.3rem',
	padding: '2.5rem 1.25rem',
};

export const appBar = {
	position: 'relative',
	backgroundColor: 'transparent',
	boxShadow: 'none',
};
